/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SearchLoupePlusIcon24Regular = forwardRef('SearchLoupePlusIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M11.75 7a.75.75 0 0 0-1.5 0v3.25H7a.75.75 0 1 0 0 1.5h3.25V15a.75.75 0 0 0 1.5 0v-3.25H15a.75.75 0 0 0 0-1.5h-3.25V7Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.503 10.995a9.492 9.492 0 1 1 18.985 0 9.455 9.455 0 0 1-2.271 6.161l4.326 4.326a.75.75 0 0 1-1.061 1.06l-4.326-4.325a9.455 9.455 0 0 1-6.16 2.27 9.492 9.492 0 0 1-9.493-9.492Zm9.492-7.992a7.992 7.992 0 1 0 0 15.984 7.992 7.992 0 0 0 0-15.984Z" })));
});
